import { isTruthyStringEnvVariable } from './util/env';

let serverApiUrl = process.env.REACT_APP_SERVER_API_URL;
let authServiceUrl = process.env.REACT_APP_AUTH_SERVICE_URL;
let serverToolsApiUrl = process.env.REACT_APP_SERVER_TOOLS_API_URL;

if (process.env.NODE_ENV === 'development') {
  const forcedEnv = localStorage.getItem('forcedEnv');
  const cloudEngine = localStorage.getItem('cloudEngine') || 'aws'; // aws or gcp
  if (['dev', 'qa', 'aqa', 'app'].includes(forcedEnv)) {
    console.log(`Forcing env to: ${forcedEnv} on ${cloudEngine}`);
    const apiDomain = `${forcedEnv}.npr.${cloudEngine}.gosimplr.com`;
    serverApiUrl = `https://${apiDomain}/api`;
    authServiceUrl = `https://${apiDomain}/api/authentication`;
    serverToolsApiUrl = `https://${apiDomain}/ecommerce`;
  }
}

const environment = {
  nodeEnv: process.env.NODE_ENV, // production | development | test - https://create-react-app.dev/docs/adding-custom-environment-variables/
  publicUrl: process.env.PUBLIC_URL, // https://create-react-app.dev/docs/using-the-public-folder/
  expertDashboardUrl: process.env.REACT_APP_EXPERT_DASHBOARD_URL,
  adminDashboardUrl: process.env.REACT_APP_ADMIN_DASHBOARD_URL,
  logicBuilderUrl: process.env.REACT_APP_LOGIC_BUILDER_URL,
  businessLoginPage: process.env.REACT_APP_BUSINESS_LOGIN_PAGE || '/business/login',

  app: {
    currentEnv: process.env.REACT_APP_NODE_ENV,
    disableErrorPopup: isTruthyStringEnvVariable(process.env.REACT_APP_DISABLE_ERROR_POPUP, false),
    serverApiUrl: serverApiUrl,
    escalationSenderEmail: process.env.REACT_APP_ESCALATION_SENDER_EMAIL,
    mfaResendCodeTimeout: process.env.REACT_APP_MFA_RESEND_CODE_TIMEOUT,
  },

  observability: {
    isTelemetryEnabled: isTruthyStringEnvVariable(process.env.REACT_APP_OPENTELEMETRY_ENABLED, false),
    telemetryUrl: process.env.REACT_APP_OPENTELEMETRY_URL,
  },

  google: {
    // REACT_APP_GOOGLE_RECAPCHA_* (missing T) is the legacy env var name, kept for backwards compatibility with Jenkins
    isGoogleReCaptchaEnabled: isTruthyStringEnvVariable(
      process.env.REACT_APP_GOOGLE_RECAPTCHA_ENABLED || process.env.REACT_APP_GOOGLE_RECAPCHA_ENABLED,
      false
    ),
    googleReCaptchaClientKey:
      process.env.REACT_APP_GOOGLE_RECAPTCHA_CLIENT_KEY || process.env.REACT_APP_GOOGLE_RECAPCHA_CLIENT_KEY,
  },

  sentry: {
    dsn: process.env.REACT_APP_SENTRY_DSN,
    release: process.env.REACT_APP_SENTRY_RELEASE,
  },

  fullStory: {
    orgId: process.env.REACT_APP_FULLSTORY_ORGID,
  },

  tools: {
    DECISION_FLOW_BASE_URL: `${serverApiUrl}/v1/decision-flow`,
    CUSTOM_INFO_WIDGETS_URL: `${serverApiUrl}/v1/custom-info-widgets`,
  },

  integrations: {
    ZENDESK_BASE_URL: `${serverApiUrl}/v1/zendesk`,
    GORGIAS_BASE_URL: `${serverApiUrl}/v1/gorgias`,
    SALESFORCE_BASE_URL: `${serverApiUrl}/v1/salesforce`,
    SALESFORCE_CHAT_V2_BASE_URL: `${serverApiUrl}/v2/salesforce-chat`,
    GLADLY_BASE_URL: `${serverApiUrl}/v1/gladly`,
    INTERCOM_BASE_URL: `${serverApiUrl}/v1/intercom`,
    ORACLE_BASE_URL: `${serverApiUrl}/v1/oracle`,
    GENESYS_BASE_URL: `${serverApiUrl}/v1/genesys`,
    COMMON_BASE_URL: `${serverApiUrl}/v1/common`,
  },

  eCommerce: {
    SHOPIFY_BASE_URL: `${serverToolsApiUrl}/v1/shopify`,
    AMAZON_BASE_URL: `${serverToolsApiUrl}/v1/amazon`,
    BIG_COMMERCE_BASE_URL: `${serverToolsApiUrl}/v1/bigCommerce`,
    REVOLVE_BASE_URL: `${serverToolsApiUrl}/v1/revolve`,
    SHIPPO_BASE_URL: `${serverToolsApiUrl}/v1/shippo`,
    COMMON_ORDERS_BASE_URL: `${serverToolsApiUrl}/v1/commonOrderService`,
    SHIPSTATION_BASE_URL: `${serverToolsApiUrl}/v1/shipstation`,
    SIMPLR_ORDER_BASE_URL: `${serverToolsApiUrl}/v1/simplrOrder`,
    RBI_BASE_URL: `${serverToolsApiUrl}/v1/rbi`,
    ORDERS_BASE_URL: `${serverToolsApiUrl}/v1/ordersService`,
    SUBSCRIPTIONS_BASE_URL: `${serverToolsApiUrl}/v1/subscriptions`,
    RETURNS_BASE_URL: `${serverToolsApiUrl}/v1/returnsService`,
    GLADLY_BASE_URL: `${serverToolsApiUrl}/v1/gladlyECommerce`,
    PRODUCTS_BASE_URL: `${serverToolsApiUrl}/v1/productService`,
    DYNAMIC_INTEGRATIONS_BASE_URL: `${serverToolsApiUrl}/dynamicIntegration`,
  },

  customerData: {
    CUSTOMER_BASE_URL: `${serverToolsApiUrl}/v1/customer`,
  },
  accountData: {
    ACCOUNT_BASE_URL: `${serverToolsApiUrl}/v1/account`,
  },

  services: {
    authServiceUrl: authServiceUrl,
    chatMLUrl: process.env.REACT_APP_CHAT_ML_URL,
    agentAssistMLUrl: process.env.REACT_APP_AGENT_ASSIST_ML_URL,
    troubleshootingAgentAssistMLUrl: process.env.REACT_APP_TROUBLESHOOTING_AGENT_ASSIST_ML_URL,
    salesAgentAssistMLUrl: process.env.REACT_APP_SALES_AGENT_ASSIST_ML_URL,
    whatOrderMlUrl: process.env.REACT_APP_WHAT_ORDER_ML_URL,
    recommendProductsUrl: process.env.REACT_APP_RECOMMEND_PRODUCTS_URL,
    easyConnectionUrl: process.env.REACT_APP_EASY_CONNECTION_URL,
    autoCompletePredictionMLUrl: process.env.REACT_APP_AUTO_COMPLETE_PREDICTION_API_URL,
    reportingUrl: process.env.REACT_APP_REPORTING_URL,
    analyticsUrl: process.env.REACT_APP_ANALYTICS_URL,
    surveyApiUrl: process.env.REACT_APP_SURVEY_URL,
    chatQuickRepliesMl: process.env.REACT_APP_CHAT_QUICK_REPLIES_URL,
    logicFlowWebUrl: process.env.REACT_APP_LOGIC_FLOW_WEB_URL,
  },
  intercom: {
    intercomId: process.env.REACT_APP_INTERCOM_ID,
    intercomAppKey: process.env.REACT_APP_INTERCOM_SECRET_KEY,
  },

  grammarly: {
    clientId: process.env.REACT_APP_GRAMMARLY_CLIENT_ID,
  },

  devtools: {
    isReactQueryDevtoolsEnabled: process.env.REACT_APP_IS_REACT_QUERY_DEVTOOLS_ENABLED,
  },

  copilot: {
    mixpanelToken: process.env.REACT_APP_COPILOT_MIXPANEL_TOKEN,
  },

  auth: {
    expertSignUpPage: process.env.REACT_APP_EXPERT_SIGN_UP_PAGE,
    partnerSignUpPage: process.env.REACT_APP_PARTNER_SIGN_UP_PAGE,
    ssoRedirectUri: process.env.REACT_APP_SSO_REDIRECT_URI,
  },

  expertContext: {
    expertEmail: process.env.REACT_APP_SIMPLR_EXPERT_EMAIL,
  },
};

export default environment;
